import LocalDraftStore from './local-draft-store';
import RemoteDraftStore from './remote-draft-store';
export const localDraftStore = new LocalDraftStore();
export const remoteDraftStore = new RemoteDraftStore();
